import styled from '@emotion/styled';
import classNames from 'classnames';
import React from 'react';

const ScrollableDiv = styled.div<Omit<Props, 'className' | 'children'>>`
  background:
    /* Shadow Cover TOP */
    linear-gradient(white 30%, rgba(255, 255, 255, 0)) center top,
    /* Shadow Cover BOTTOM */ linear-gradient(rgba(255, 255, 255, 0), white 70%) center bottom,
    /* Shadow TOP */ radial-gradient(farthest-side at 50% 0, rgba(0, 0, 0, 0.2) 10px, rgba(0, 0, 0, 0)) center
      top,
    /* Shadow BOTTOM */ radial-gradient(farthest-side at 50% 100%, rgba(0, 0, 0, 0.2) 10px, rgba(0, 0, 0, 0))
      center bottom;
  background-repeat: no-repeat;
  background-size:
    100% 40px,
    100% 40px,
    100% 14px,
    100% 14px;
  background-attachment: local, local, scroll, scroll;
  overflow-y: scroll;
  min-height: 120px;

  max-height: ${({ desktopMaxHeight }) => desktopMaxHeight};
  @media screen and (max-width: 767px) {
    max-height: ${({ mobileMaxHeight }) => mobileMaxHeight};
  }

  ${({ mode }) =>
    mode === 'grid' &&
    `
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      place-items: center;
      gap: 12px;

      @media screen and (min-width: 375px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }
    `}
`;

type Props = {
  children: React.ReactNode;
  mode?: 'default' | 'grid';
  className?: string;
  desktopMaxHeight?: string;
  mobileMaxHeight?: string;
};

const DesignGridWrapper = ({
  children,
  mode = 'default',
  className = '',
  desktopMaxHeight = '360px',
  mobileMaxHeight = 'calc(100dvh - 380px)',
}: Props) => {
  return (
    <ScrollableDiv
      mode={mode}
      desktopMaxHeight={desktopMaxHeight}
      className={classNames(className)}
      mobileMaxHeight={mobileMaxHeight}>
      {children}
    </ScrollableDiv>
  );
};

export default DesignGridWrapper;
